//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mgop } from '@aligov/jssdk-mgop'
import Toast from '@components/common/toast'
export default {
  name: 'Index',
  components: {
    mgop: mgop
  },
  data () {
    return {}
  },
  mounted () {
    // this.zz()
    aplus_queue.push({
      action: 'aplus.sendPV', // 暂时固定使用 sendPV 方式推送
      arguments: [
        {
          is_auto: false
        },
        {
          app_id: '100604', // 应用ID
          app_name: '杭州违法举报', // 应用名称
          event_id: '3000hctxz100604XX0', // 业务唯一标识
          event_name: '首页', // 当前页面名称
          client_type: 'jcss' // 客户端类型  zlb：浙里办，jcss：警察叔叔，zfb：支付宝（小程序）
        }
      ]
    })
  },
  methods: {
    zz () {
      mgop({
        api: 'mgop.trustway.wfjb.auth', // 必须
        host: 'https://bus-jcss.police.hangzhou.gov.cn/openapi',
        dataType: 'JSON',
        type: 'GET',
        data: {
          platformId: 8
        },
        appKey: 'sjwy7hsc+2001300008+dycyyb',
        onSuccess: (data) => {
          console.log(data, '000000')
          // Indicator.close();
          if (data.code == 200) {
            if (data.data.isReal !== '1') {
              Toast.show({
                message: '您还未实名，请先实名'
                // type: 'warn'
              })
            }
            localStorage.removeItem('currentType')
            localStorage.setItem('token', data.data.token)
            setTimeout(() => {
              this.$router.replace({
                name: 'vioReportIndex',
                path: '/vioReportIndex'
              })
            }, 1000)
          } else {
            Toast.show({
              message: '获取用户token失败！'
              // type: 'warn'
            })
          }
        },
        onFail: (err) => {
          //  next()
          console.log(err, 'err--------=====--------')
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/vioReport/repaire.vue